import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form } from "react-bootstrap";
import { commonservices } from "../services/CommonServices";
import infoIcon from "../assets/images/infobtnblue.svg";

function RejectModal(props) {
  const [input, setInput] = useState({
    commentBox: props?.checkListData?.commentField
      ? props?.checkListData?.commentField
      : "",
    errors: {
      commentBox: "",
      ValidationRules: [
        {
          FieldName: "commentBox",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  });
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="reject-comment-modal"
      backdrop="static"
    >
      <Modal.Header closeButton>
        Comment ({props?.checkListData?.heading})
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="form-group mb16">
          <Form.Label className="common-label">
            Write a Comment<span className="ms-1 red-color-text">*</span>
          </Form.Label>
          <div className="position-relative">
            <Form.Control
              as="textarea"
              type="text"
              placeholder="Comment"
              maxLength="500"
              value={input?.commentBox}
              disabled={props?.checkListData?.submitDisable}
              className="common-input h-auto"
              onChange={(e) => {
                setInput({
                  ...input,
                  commentBox: e.target.value,
                });
              }}
              rows={5}
              isInvalid={input.errors.commentBox}
            />
            {input.errors.commentBox && (
              <Form.Control.Feedback type="invalid">
                <span className="error-message-icon">
                  <img
                    src={infoIcon}
                    alt="infoIcon"
                    title={input.errors.commentBox}
                  />
                </span>
              </Form.Control.Feedback>
            )}
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button className="grey-btn w-auto" onClick={props.onHide}>
          Close
        </button>
        <button
          className="blue-btn w-auto"
          disabled={props?.checkListData?.submitDisable}
          onClick={() => {
            let validation = commonservices.fnCheckValidationOfObject(input);
            if (validation?.isValid) {
              let body = props?.checkListData?.body
                ? { ...props?.checkListData?.body }
                : {};
              body.commentfieldvalue = input?.commentBox;
              props?.updateReviewStatus(body);
              props?.handleCheckListStatus(
                body?.booleanfield,
                body?.booleanfieldvalue,
                body?.commentfield,
                body?.commentfieldvalue
              );
              props.onHide();
            } else {
              setInput({ ...validation?.obj });
            }
          }}
        >
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default RejectModal;
